export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          textTransform: 'none',
          fontWeight: 500,
          padding: theme.spacing(1, 3),
          boxShadow: 'none',
          '&:hover': {
            boxShadow: theme.shadows[2],
          },
        },
        // Primary contained buttons: solid black background with white text
        containedPrimary: {
          backgroundColor: '#000000',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#333333',
            boxShadow: theme.shadows[4],
          },
        },
        // Secondary outlined buttons: black outline with black text
        outlinedSecondary: {
          borderColor: '#000000',
          borderWidth: 1.5,
          color: '#000000',
          '&:hover': {
            borderColor: '#000000',
            borderWidth: 1.5,
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
        // General contained variant fallback
        contained: {
          '&:hover': {
            boxShadow: theme.shadows[4],
          },
        },
        // General outlined variant fallback
        outlined: {
          borderWidth: 1.5,
          '&:hover': {
            borderWidth: 1.5,
          },
        },
        text: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        sizeSmall: {
          padding: theme.spacing(0.5, 2),
          fontSize: '0.875rem',
        },
        sizeLarge: {
          padding: theme.spacing(1.5, 4),
          fontSize: '1rem',
        },
      },
    },
  };
}

